<template>
  <div class="short-container">
    <a
      :href="`/creator/flix-playlist/${playlist}/details`"
      class="btn btn-primary mb-3"
      v-if="!handleNullablePlaylist()"
      >Back</a
    >

    <div
      class="row h-100 w-100"
      v-if="video == null && !checkVideoType()"
    >
      <uploaderCard
        @handleVideoUpload="handleVideoUpload"
        @handleVideoType="handleVideoType"
      />
    </div>
    <div
      class="card p-4"
      v-else
    >
      <div class="row upload-container">
        <div
          class="col-3"
          v-if="!checkVideoType()"
        >
          <previewVideo
            :video_url="video"
            :name="file?.name"
            @handleVideoUpload="handleVideoUpload"
          />
        </div>
        <div class="col-9">
          <form>
            <div class="form-group">
              <label for="title">Select Video Types</label>
              <select
                class="form-control"
                id="videoType"
                v-model="inside_type"
                @change="handleVideoType"
              >
                <option
                  :value="'upload'"
                  :selected="inside_type === 'upload'"
                >
                  Upload
                </option>
                <option
                  :value="'cloudflare'"
                  :selected="inside_type === 'cloudflare'"
                >
                  Cloudflare ID
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label
                for="title"
                class="form-label"
                >Title</label
              >
              <input
                type="text"
                class="form-control"
                id="title"
                aria-describedby="titleHelp"
                placeholder="Enter title"
                v-model="form.title"
              />
              <div
                id="titleHelp"
                class="form-text"
              >
                Enter title of the video
              </div>
            </div>
            <div class="mb-3">
              <label
                for="description"
                class="form-label"
                >Description(Optional)</label
              >
              <textarea
                id="description"
                required
                cols="10"
                rows="5"
                class="form-control resize--none"
                v-model="form.description"
              ></textarea>
            </div>

            <!-- <div class="mb-3">
              <div class="form-group row">
                <item-type-component
                  v-for="item in versions"
                  :key="item.value"
                  :active="form.version === item.value"
                  size="col-md-6"
                  :title="item.title"
                  v-on:clicked="() => changeVersion(item.value)"
                />
              </div>
            </div> -->

            <div
              class="mb-3"
              v-if="handleNullablePlaylist()"
            >
              <label
                for="playlist"
                class="form-label"
                >PlayLists</label
              >
              <multiselect
                v-model="form.playlist"
                :options="playlistOptions"
                placeholder="Select playlist"
                track-by="id"
                label="name"
              ></multiselect>
            </div>

            <!-- <div class="mb-3">
              <label
                for="tags"
                class="form-label"
                >Tags</label
              >
              <multiselect
                v-model="form.tags"
                tag-placeholder="Add this as new tag"
                placeholder="Add tags"
                label="name"
                track-by="name"
                :options="options"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              ></multiselect>
              <div
                id="tagsHelp"
                class="form-text"
              >
                Enter tags for the video
              </div>
            </div> -->

            <div class="mb-3"
            v-if="handleNullablePlaylist()"
            >
              <label
                for="category"
                class="form-label"
                >Tags</label
              >
              <multiselect
                v-model="form.category"
                :options="categories"
                placeholder="Select Tags"
                track-by="value"
                label="title"
                :multiple="true"
              ></multiselect>
            </div>
            <!-- <div class="mb-3">
              <label for="item Category"
              class="form-label"
              >Item Category</label>
              <multiselect
                v-model="form.item_category"
                :options="getItemCategories()"
                placeholder="Select Item Category"
                track-by="value"
                label="title"
              ></multiselect>
            </div> -->

            <div class="mb-3">
              <label
                for="thumbnail"
                class="form-label"
                >Thumbnail (Optional)</label
              >
              <upload-images
                :multiple="false"
                label="Click or drag and drop to upload A Thumbnail (Optional)"
                v-model="form.thumbnail"
              />
            </div>

            <div class="mb-3 d-flex">
              <div class="checkbox__body">Mark as Highlight</div>
              <label class="checkbox style-e">
                <input
                  type="checkbox"
                  v-model="form.highlight"
                />
                <div class="checkbox__checkmark"></div>
              </label>
            </div>

            <div class="mb-3">
              <label
                for="cloudflare_id"
                class="form-label"
                >Cloudflare ID (Optional)</label
              >
              <input
                type="text"
                class="form-control"
                id="cloudflare_id"
                aria-describedby="cloudflare_idHelp"
                placeholder="Enter cloudflare id"
                v-model="form.cloudflare_id"
              />
            </div>

            <div
              class="mt-35 mb-4 row d-flex justify-content-center items-center"
            >
              <button
                type="button"
                class="btn btn-danger col-3"
                @click.prevent="handleDiscard"
              >
                Discard
              </button>
              <button
                class="btn btn-primary align-middle col-3 ml-10"
                @click.prevent="submit"
                :disabled="loading"
              >
                {{ loading ? 'Uploading...' : 'Upload' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploaderCard from './uploader.vue';
import previewVideo from '../components//preview-video.vue';
import ItemTypeComponent from '../../components/ItemTypeComponent';
import Multiselect from 'vue-multiselect';
import UploadImages from '../../components/upload-images';
import axios from 'axios';

export default {
  name: 'createItem',
  components: {
    uploaderCard,
    previewVideo,
    Multiselect,
    ItemTypeComponent,
    UploadImages,
  },

  props: ['plans', 'route', 'playlist', 'discardroute','category'],

  data() {
    return {
      video: null,
      file: null,
      versions: [
        { value: 0, title: 'Video is Free' },
        { value: 1, title: 'Video is Paid' },
      ],
      categories: [
        { value: 'action', title: 'Action' },
        { value: 'comedy', title: 'Comedy' },
        { value: 'drama', title: 'Drama' },
        { value: 'horror', title: 'Horror' },
        { value: 'romance', title: 'Romance' },
        { value: 'thriller', title: 'Thriller' },
      ],
      options: [],
      playlistOptions: [],

      form: {
        item_type: 1,
        version: 0,
        // plans: [],
        tags: [],
        video: null,
        thumbnail: null,
        title: '',
        description: '',
        playlist: null,
        category: null,
        highlight: null,
        cloudflare_id: '',
        item_category:{
          value: '',
          title: '',
        }
      },
      loading: false,
      video_type: 'upload',
      inside_type: 'upload',
    };
  },
  mounted() {
    if (this.handleNullablePlaylist()) {
      this.handleGetActivePlaylists();
    }
  },

  methods: {
    handleVideoUpload({ file, videoUrl }) {
      this.file = file;
      this.video = videoUrl;

      this.form.title = this.file?.name || '';
    },
    // getItemCategories(){
    //   const categories =[];
    //   this.category?.forEach((category) => {
    //     categories.push({
    //       value: category.id,
    //       title: category.name,
    //     });
    //   });
    //   return categories;
    // },
    changeVersion(version) {
      this.form.version = version;
      this.form.thumbnail = null;
    },
    nameWithLang({ name, pricing, duration }) {
      return `${name} — ${Number(pricing)} RWF for ${duration} days`;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
      };
      this.options.push(tag);
      this.form.tags.push(tag);
    },

    removeTag(tag) {
      const index = this.form.tags.indexOf(tag);
      if (index >= 0) {
        this.form.tags.splice(index, 1);
      }
    },

    async submit() {
      if (this.file == null && !this.checkVideoType()) {
        notify('error', 'Uploading video is required');
        return;
      }
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('description', this.form.description);
        for (let i = 0; i < this.form?.tags?.length; i++) {
          formData.append('tags[]', this.form.tags[i].name);
        }

        for (let i = 0; i < this.form?.category?.length; i++) {
          formData.append('tags[]', this.form.category[i].value);
        }

        formData.append('version', this.form.version);
        formData.append('item_type', this.form.item_type);

        if (this.handleNullablePlaylist()) {
          formData.append('flix_playlist_id', this.form.playlist?.value);
        } else {
          formData.append('flix_playlist_id', this.playlist);
        }

        formData.append('highlight', this.form.highlight);

        if (!this.checkVideoType()) {
          formData.append('video', this.file);
        }

        if(this.form.cloudflare_id == '' && this.checkVideoType()) {
          notify('error', 'Cloudflare ID is required');
          return;
        }
        if (this.form.cloudflare_id !== '' && this.checkVideoType()) {
          formData.append('cloudflare_id', this.form.cloudflare_id);
        }

        if (this.form.thumbnail !== null)
          formData.append('thumbnail', this.form.thumbnail[0].image);

          // if(this.form.item_category.value !== ''){
          //   formData.append('item_category', this.form.item_category.value);
          // }
        const res = await axios.post(this.route, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (res.data.errors) {
          notify('error', res.data.errors);
        } else {
          notify('success', 'Post uploaded successfully!');

          this.reset();
          window.location = this.discardroute;
        }
      } catch (e) {
        notify('error', 'Something went wrong');
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    reset() {
      this.form = {
        item_type: 1,
        version: 0,
        tags: [],
        video: null,
        title: '',
        description: '',
        playlist: null,
        thumbnail: null,
        highlight: null,
        cloudflare_id: '',
        // item_category:{
        //   value: '',
        //   title: '',
        // }
      };
    },

    handleDiscard() {
      window.addEventListener('beforeunload', function (event) {
        event.preventDefault();
        event.returnValue = 'Are you sure you want to leave this page?';
      });
      window.location = this.discardroute;
    },

    handleGetActivePlaylists() {
      this.playlistOptions.push({ value: null, name: 'No Playlist' });
      axios
        .get('/creator/flix-playlist/all')
        .then((res) => {
          var playlists = res.data.data;
          playlists?.forEach((playlist) => {
            this.playlistOptions.push({
              value: playlist.id,
              name: playlist.name,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleNullablePlaylist() {
      if (this.playlist == 'null') {
        return true;
      }
      return false;
    },
    handleVideoType(videoType) {
      this.video_type = videoType;
      this.inside_type = this.video_type;
    },
    handleChangeVideoType() {
      this.video = null;
      this.file = null;
      this.video_type = this.inside_type;
    },

    checkVideoType() {
      if (this.video_type === 'cloudflare') {
        return true;
      }
      return false;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btn-primary {
  padding: 10px 20px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  border: solid #0f4c47 1px;
  color: white;
  background-color: #0f4c47;
  transition: 0.2s;

  &:hover {
    background-color: #ffff;
    color: #0f4c47;
  }
}
@media screen and (max-width: 768px) {
  .order-1 {
    order: 2;
  }
  .order-2 {
    order: 1;
  }
}

.style-e {
  display: inline-block;
  position: relative;
  padding-left: 50px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.style-e input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.style-e input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e input:checked ~ .checkbox__checkmark:after {
  left: 21px;
}
.style-e:hover input ~ .checkbox__checkmark {
  background-color: #eee;
}
.style-e:hover input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e .checkbox__checkmark {
  position: absolute;
  top: 1px;
  left: 0;
  height: 22px;
  width: 40px;
  background-color: #eee;
  transition: background-color 0.25s ease;
  border-radius: 11px;
}
.style-e .checkbox__checkmark:after {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 16px;
  height: 16px;
  display: block;
  background-color: #fff;
  border-radius: 50%;
  transition: left 0.25s ease;
}

.checkbox__body {
  color: #333;
  line-height: 1.4;
  transition: color 0.25s ease;
  margin-right: 10px;
}
</style>
